<script lang="ts">
    import { invalidateAll } from '$app/navigation';
    import { goto } from '$app/navigation';

    let username = $state('');
    let password = $state('');

    async function submit(event: Event) {
        event.preventDefault();

        const response = await fetch('/admin/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                username,
                password
            })
        });
        console.log(response);

        if (response.ok) {
            await invalidateAll();
            goto('/admin');
        } else {
            alert('Błędny login lub hasło');
        }
    }
</script>


    <h1 class="heading">Logowanie</h1>

     <form onsubmit={submit} class="form-group">
            <input 
                type="text" 
                name="username" 
                placeholder="Login" 
                class="form-control"
                bind:value={username}
            />
            <input 
                type="password" 
                name="password" 
                placeholder="Hasło" 
                class="form-control"
                bind:value={password}
            />
            <div class="place-end">
                <button type="submit" class="btn">Zaloguj</button>
            </div>
        </form>
